<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">データ取得</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<router-link class="uk-button uk-button-default" to="/main_office">戻る</router-link>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<div class="uk-form-horizontal">
				<div id="select_box_list" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
					<div>
						<label class="uk-form-label" for="department">部門</label>
						<div class="uk-form-controls">
							<select id="department" name="department" class="uk-select" v-model="sel_department">
								<option value="">すべて</option>
								<template v-for="(department, index) in all_department">
									<option :value="department.department_code" :key="index">{{department.department_name}}</option>
								</template>
							</select>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="division">部</label>
						<div class="uk-form-controls">
							<select id="division" name="division" class="uk-select" v-model="sel_division">
								<option value="">すべて</option>
								<template v-for="(devision, index) in getDivision">
									<option :value="devision.division_code" :key="index">{{devision.division_name}}</option>
								</template>
							</select>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="section">課</label>
						<div class="uk-form-controls">
							<select id="section" name="section" class="uk-select" v-model="sel_section">
								<option value="">すべて</option>
								<template v-for="(section, index) in getSection">
									<option :value="section.section_code" :key="index">{{section.section_name}}</option>
								</template>
							</select>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="am_area">AMエリア</label>
						<div class="uk-form-controls">
							<select id="am_area" name="am_area" class="uk-select" v-model="sel_am_area">
								<option value="">すべて</option>
								<template v-for="(am_area, index) in getAmArea">
									<option :value="am_area.am_area_code" :key="index">{{am_area.am_area_name}}</option>
								</template>
							</select>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="shop">店舗</label>
						<div class="uk-form-controls">
							<select id="shop" name="shop" class="uk-select" v-model="sel_shop">
								<option value="">すべて</option>
								<template v-for="(shop,index) in getShops">
									<option v-bind:value="shop.code" :key="index">{{ shop.name }}</option>
								</template>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<div class="uk-form-horizontal">
				<div id="date_picker" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
					<div>
						<label class="uk-form-label" for="start">開始</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-date-picker id="start" name="start" v-model="start_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
							<template v-else>
								<el-date-picker id="start" name="start" v-model="start_date_picker" format="yyyy/MM/dd" :type="date" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
						</div>
					</div>
					<div>
						<label class="uk-form-label" for="start">終了</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-date-picker id="end" name="end" v-model="end_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
							<template v-else>
								<el-date-picker id="end" name="end" v-model="end_date_picker" format="yyyy/MM/dd" :type="date" :picker-options="date_picker_options" placeholder="YYYY/MM/DD"></el-date-picker>
							</template>
						</div>
					</div>
				</div>
			</div>
			<p>期間を指定した場合、その期間中に完了したToDoの一覧が出力されます。</p>
		</div>
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<div id="download_list" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
				<div>
					<button class="uk-button uk-button-default uk-text-capitalize" @click="downloadTodoCsv">ToDo CSVダウンロード</button>
				</div>
				<div>
					<button class="uk-button uk-button-default" @click="downloadReservationCsv">予定表 CSVダウンロード</button>
				</div>
			</div>
		</div>
		<!--/ Main -->
	</div>
</template>

<script>
	import Shop from '@/api/Shop'
	import CsvExport from '@/api/CsvExport'
	import Role from '@/api/Role'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import StaffAuth from '@/api/StaffAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'

	export default {
		name: 'MainOfficeExportDataPage',
		data () {
			return {
				shops: [],
				all_am_area: [],
				all_department: [],
				all_division: [],
				all_section: [],
				sel_department: '',
				sel_division: '',
				sel_section: '',
				sel_am_area: '',
				sel_shop: '',
				start_date_picker: '',
				end_date_picker: '',
				date_picker_options: {
					format: 'yyyy/MM/dd'
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				// StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/main_office/login')
								location.reload()
							})
						// })
					// })
				// })
			},
			downloadReservationCsv () {
				let self = this
				let department = $('#department option:selected').val()
				let division = $('#division option:selected').val()
				let section = $('#section option:selected').val()
				let am_area = $('#am_area option:selected').val()
				let code = $('#shop option:selected').val()
				let start = moment(self.start_date_picker).format('YYYY-MM-DD')
				let end = moment(self.end_date_picker).format('YYYY-MM-DD')

				let params = new URLSearchParams()

				if (department != null) {
					params.append('department_code', department)
				}
				if (division != null) {
					params.append('division_code', division)
				}
				if (section != null) {
					params.append('section_code', section)
				}
				if (am_area != null) {
					params.append('am_area_code', am_area)
				}
				if (code != null) {
					params.append('code', code)
				}
				if (start != null) {
					params.append('start', start)
				}
				if (end != null) {
					params.append('end', end)
				}

				CsvExport.reservationAll(params).then(function (response) {
					window.location.href = response.data.data
				})
			},
			downloadTodoCsv () {
				let self = this
				let department = $('#department option:selected').val()
				let division = $('#division option:selected').val()
				let section = $('#section option:selected').val()
				let am_area = $('#am_area option:selected').val()
				let code = $('#shop option:selected').val()
				let start = moment(self.start_date_picker).format('YYYY-MM-DD')
				let end = moment(self.end_date_picker).format('YYYY-MM-DD')

				let params = new URLSearchParams()

				if (department != null) {
					params.append('department_code', department)
				}
				if (division != null) {
					params.append('division_code', division)
				}
				if (section != null) {
					params.append('section_code', section)
				}
				if (am_area != null) {
					params.append('am_area_code', am_area)
				}
				if (code != null) {
					params.append('code', code)
				}
				if (start != null) {
					params.append('start', start)
				}
				if (end != null) {
					params.append('end', end)
				}

				CsvExport.todoAll(params).then(function (response) {
					window.location.href = response.data.data
				})
			},
			loadShops () {
				let self = this

				let params = new URLSearchParams()
				params.append('status', 0)

				Shop.all(params).then(function (response) {
					self.shops = response.data.data
				})
			},
			loadData () {
				let self = this

				Shop.all_am_area().then(function (response) {
					self.all_am_area = response.data.data
				})

				Shop.all_department().then(function (response) {
					self.all_department = response.data.data
				})

				Shop.all_division().then(function (response) {
					self.all_division = response.data.data
				})

				Shop.all_section().then(function (response) {
					self.all_section = response.data.data
				})
			},
			isNullOrUndefined (checkValue) {
				if (checkValue === undefined || checkValue === null) {
					return true
				}
				return false
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			}
		},
		created () {
		},
		beforeMount () {
			this.loadData()
			this.loadShops()
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_main_office != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})
		},
		computed: {
			getDepartment: {
				get: function () {
					let self = this
					return self.all_department.filter(function (item) {
						return item
					})
				}
			},
			getDivision: {
				get: function () {
					let self = this
					let chk_val = false
					let fil_division = []
					// 部門コードでフィルタリング
					let result = self.all_division.filter(function (item) {
						if (self.isNullOrUndefined(item.department_code)) {
							item.department_code = ''
						}
						if (item.department_code.indexOf(self.sel_department) !== -1 && (item.department_code == self.sel_department || self.sel_department == '')) {
							if (item.division_code == self.sel_division) {
								chk_val = true
							}
							if (fil_division.includes(item.division_code)) {
								// コード重複は選択肢にださない
								return false
							} else {
								fil_division.push(item.division_code)
								return true
							}
						}
						return false
					})
					// フィルタ結果、選択された項目が存在しない場合はクリアする
					if (chk_val === false) {
						self.sel_division = ''
					}
					return result
				}
			},
			getSection: {
				get: function () {
					let self = this
					let chk_val = false
					let fil_section = []
					let result = self.all_section.filter(function (item) {
						// 部門コードでフィルタリング
						if (self.isNullOrUndefined(item.department_code)) {
							item.department_code = ''
						}
						if (item.department_code.indexOf(self.sel_department) !== -1 && (item.department_code == self.sel_department || self.sel_department == '')) {
							// 部コードでフィルタリング
							if (self.isNullOrUndefined(item.division_code)) {
								item.division_code = ''
							}
							if (item.division_code.indexOf(self.sel_division) !== -1 && (item.division_code == self.sel_division || self.sel_division == '')) {
								if (item.section_code == self.sel_section) {
									chk_val = true
								}
								if (fil_section.includes(item.section_code)) {
									// コード重複は選択肢にださない
									return false
								} else {
									fil_section.push(item.section_code)
									return true
								}
							}
						}
						return false
					})
					// フィルタ結果、選択された項目が存在しない場合はクリアする
					if (chk_val === false) {
						self.sel_section = ''
					}
					return result
				}
			},
			getAmArea: {
				get: function () {
					let self = this
					let chk_val = false
					let fil_am_area = []
					let result = self.all_am_area.filter(function (item) {
						// 部門コードでフィルタリング
						if (self.isNullOrUndefined(item.department_code)) {
							item.department_code = ''
						}
						if (item.department_code.indexOf(self.sel_department) !== -1 && (item.department_code == self.sel_department || self.sel_department == '')) {
							// 部コードでフィルタリング
							if (self.isNullOrUndefined(item.division_code)) {
								item.division_code = ''
							}
							if (item.division_code.indexOf(self.sel_division) !== -1 && (item.division_code == self.sel_division || self.sel_division == '')) {
								// 課コードでフィルタリング
								if (self.isNullOrUndefined(item.section_code)) {
									item.section_code = ''
								}
								if (item.section_code.indexOf(self.sel_section) !== -1 && (item.section_code == self.sel_section || self.sel_section == '')) {
									if (item.am_area_code == self.sel_am_area) {
										chk_val = true
									}
									if (fil_am_area.includes(item.am_area_code)) {
										// コード重複は選択肢にださない
										return false
									} else {
										fil_am_area.push(item.am_area_code)
										return true
									}
								}
							}
						}
						return false
					})
					// フィルタ結果、選択された項目が存在しない場合はクリアする
					if (chk_val === false) {
						self.sel_am_area = ''
					}
					return result
				}
			},
			getShops: {
				get: function () {
					let self = this
					let chk_val = false
					let result = self.shops.filter(function (item) {
						let department_code = ''
						let division_code = ''
						let section_code = ''
						let am_area_code = ''

						// nullの場合は空白として処理する
						if (!self.isNullOrUndefined(item.department_code)) {
							department_code = item.department_code
						}
						if (!self.isNullOrUndefined(item.division_code)) {
							division_code = item.division_code
						}
						if (!self.isNullOrUndefined(item.section_code)) {
							section_code = item.section_code
						}
						if (!self.isNullOrUndefined(item.am_area_code)) {
							am_area_code = item.am_area_code
						}
						// 部門コードでフィルタリング
						if (department_code.indexOf(self.sel_department) !== -1 && (department_code == self.sel_department || self.sel_department == '')) {
							// 部コードでフィルタリング
							if (division_code.indexOf(self.sel_division) !== -1 && (division_code == self.sel_division || self.sel_division == '')) {
								// 課コードでフィルタリング
								if (section_code.indexOf(self.sel_section) !== -1 && (section_code == self.sel_section || self.sel_section == '')) {
									// AMエリアコードでフィルタリング
									if (am_area_code.indexOf(self.sel_am_area) !== -1 && (am_area_code == self.sel_am_area || self.sel_am_area == '')) {
										if (item.code == self.sel_shop) {
											chk_val = true
										}
										return true
									}
								}
							}
						}
						return false
					})
					// フィルタ結果、選択された項目が存在しない場合はクリアする
					if (chk_val === false) {
						self.sel_shop = ''
					}
					return result
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	input[type="date"]::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/page/MainOfficeExportDataPage.vue